import { dddList } from 'services/searchTrucker/constants';

export function validateCpf(cpf: string): boolean {
  const cpfTemp = cpf.replace(/\D/g, '');

  if (cpfTemp.toString().length !== 11 || /^(\d)\1{10}$/.test(cpfTemp)) {
    return false;
  }

  let result = true;

  [9, 10].forEach((j) => {
    let sum = 0;
    let r;

    cpfTemp
      .split(/(?=)/)
      .splice(0, j)
      .forEach((e, i) => {
        sum += parseInt(e, 10) * (j + 2 - (i + 1));
      });

    r = sum % 11;
    r = r < 2 ? 0 : 11 - r;

    if (r !== parseInt(cpfTemp.substring(j, j + 1), 10)) {
      result = false;
    }
  });
  return result;
}

// eslint-disable-next-line
export function isEmpty(element: any) {
  if (
    element === '' ||
    element === undefined ||
    element === null ||
    element === 'undefined' ||
    !/[^\s]/.test(element) ||
    /^\s*$/.test(element)
  ) {
    return true;
  }

  return false;
}

export const isPhone = (phoneNumber: string) => {
  const match = phoneNumber.match(/^(\d{2})(9\d{8})$/);
  return match && dddList.includes(parseInt(match[1], 10));
};
